export default "__VITE_PUBLIC_ASSET__2a683a38__"